export default [

    {
      path: '/commissions/bordereaux/details',
      name: 'bordereaux-details',
      component: () => import('@/views/commissions/BordereauDetails.vue'),
    },
    {
        path: '/commissions/bordereaux',
        name: 'commissions-list',
        component: () => import('@/views/commissions/Bordereau.vue'),
    },
    {
      path: '/commissions/rapprochements',
      name: 'rapprochements',
      component: () => import('@/views/commissions/Rapprochement.vue'),
    },
    {
      path: '/commissions/reglements',
      name: 'reglements',
      component: () => import('@/views/commissions/Reglement.vue'),
    },
    {
      path: '/commissions/syntheses',
      name: 'syntheses',
      component: () => import('@/views/commissions/Synthese.vue'),
    }
  ]
  